module.exports = __webpack_public_path__ + "img/dash-card-amount-sales.ed1e46ca.svg";